import React from 'react';
import { Icon } from './Icon.jsx';

const SIZES = { sm: { box: 34, icon: 16, r: 'var(--radius-sm)' }, md: { box: 42, icon: 20, r: 'var(--radius-md)' }, lg: { box: 52, icon: 24, r: 'var(--radius-lg)' } };
const VARIANTS = {
  solid:   { bg: 'var(--primary)',  fg: 'var(--on-primary)', bd: 'transparent',        hover: 'var(--primary-hover)' },
  soft:    { bg: 'var(--primary-soft)', fg: 'var(--primary)', bd: 'transparent',        hover: 'var(--dala-red-soft)' },
  outline: { bg: 'transparent',     fg: 'var(--text-strong)', bd: 'var(--border-strong)', hover: 'var(--surface-hover)' },
  ghost:   { bg: 'transparent',     fg: 'var(--text-body)',  bd: 'transparent',        hover: 'var(--surface-hover)' },
};

/** IconButton — square, rounded control for icon-only actions (toolbars, headers). */
export function IconButton({ icon, variant = 'ghost', size = 'md', label, disabled = false, style, ...rest }) {
  const s = SIZES[size] || SIZES.md;
  const v = VARIANTS[variant] || VARIANTS.ghost;
  const [hover, setHover] = React.useState(false);
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: s.box, height: s.box, borderRadius: s.r,
        background: hover && !disabled ? v.hover : v.bg,
        color: v.fg,
        border: `2px solid ${v.bd}`,
        cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
        transition: 'background var(--dur-fast) var(--ease-out)',
        ...style,
      }}
      {...rest}
    >
      <Icon name={icon} size={s.icon} />
    </button>
  );
}
